
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rejestracja-firmy",
      function () {
        return require("private-next-pages/rejestracja-firmy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rejestracja-firmy"])
      });
    }
  